module.exports = __webpack_public_path__ + "static/media/google-assistant@2x.6a05823b.jpg";